<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党员教育</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input 
								style="width: 200px;"
								v-model="getdata.title" 
								size="small"
								placeholder="输入标题查询"
								@input="getdata.page = 1;totalPage = 0;dataList();"></el-input>
							<el-select
								style="margin-left: 10px;width:120px" 
								size="small"
								v-model="getdata.year" placeholder="请选择年份"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
								<el-option
									:key="index"
									v-for="(item,index) in $yearList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" @click="delAll">一键删除</el-button>
							<el-button type="primary" size="small" @click="goadd">新建任务</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							@selectEnable="selectEnable"
							:tableData="tableData"
							delkey="id"
                            :tableHeader="tableHeader"
							@selectList="selectList"
                            :loading="true" 
							:indexs="false"
							:selection="true">
						</myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import tree from '@/components/tree.vue'
	import { xxjy,dwgl } from '@/axios'
	import Page from '@/components/page.vue'
	import { Message } from 'element-ui'
	import DelData from '@/components/delToast.vue'
	import myTables from '@/components/tables/tables.vue'
	let that;
	export default{
		data(){
			return{
				getdata:{
					id: this.$store.state.user.userinfo.id,
					year: "",
					flag:this.$store.state.user.userinfo.flag,
					title:"",
					page: 1,
				},
				dw:this.$store.state.user.userinfo.dw,
				delList:[],
				tableData:[],
				totalPage:0,
				studyNum:0,
				studyTime:0,
				tableHeader: [     // 表头
					{prop: 'title', label: '主题'},
					// 如果后端传过来的值不是我们所预期的，此处可以如下判断修改，isok是是否需要渲染为el-tag,效果为下图
					{prop: 'dw', label: '所属组织',width:"120"},
					{prop: 'k_time', label: '时间',width:"160"},
					{prop: 'dw', label: '发布党组织',width:"120"},
					// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
					{
						prop: 'oper', label: '操作', fixed: 'right', width: '120',
						oper: [
							{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail,show:true},
							{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit,show:this.$store.state.user.userinfo.id == this.value},
							{name: '删除', style: {color:'#bb0000'}, clickFun: this.del,show:this.$store.state.user.userinfo.id == this.value},
						]
					}
				],
			}
		},
		components:{tree,Page,DelData,myTables},
		created(){that = this;},
		methods:{
			// 关闭新增或编辑弹窗
			closeWin(){
				this.dialogVisible = false;
			},
			// 新增
			goadd(){
				that.$router.push({
					path:'/grxx_add',
					query:{
						uid:that.getdata.id,
						type:'add',
						flag:that.getdata.flag,
						dw:that.dw,
					},
				})
			},
			// 数据
			dataList(){
				xxjy.taskPersonStudy(that.getdata).then(res => {
					if(res.data.pagedata.length>0){
						that.tableData = res.data.pagedata;
						that.totalPage = res.data.count;
					}else{
						that.tableData = [];
						that.totalPage = 0;
					}
				})
			},
			
			// 分页查询
			changedata(current){
				that.getdata.page = current;
				that.dataList();
			},
			// 树形结构筛选
			treeSelect(data){
				that.getdata.id = data.id;
				that.getdata.flag = data.flag;
				that.dw = data.dw;
				that.getdata.page = 1;
				that.dataList();
			},
			// 详情
			showDetail(data){
				that.$router.push({
					path:"/grxx_detaill",
					query:{
						hy_flag:data.hy_flag,
						hyid:data.id,
						dw:that.dw,
						uid:that.getdata.id,
					}
				})
			},
			
			// 编辑
			edit(data){
				that.$router.push({
					path:"/grxx_add",
					query:{
						hyid:data.id,
						hy_flag:data.hy_flag,
						flag:that.getdata.flag,
						type:'edit',
						dw:data.dw,
						uid:that.getdata.id,
						pub_id:data.pub_id,
						pub_flag:data.pub_flag
					}
				})
			},
			// 一键删除
			selectList(value){
				that.delList =value;
			},
			// 部分禁用删除
			selectEnable(row, rowIndex) {
				if (row.pub_flag == that.$store.state.user.userinfo.flag&&row.pub_id == that.$store.state.user.userinfo.id) {
				return true
				}
			},
			delAll(){
				if(that.delList.length == 0){
					Message.warning('请先选择要删除得数据')
				}else{
					that.delData();
				}
			},
			// 部分禁用删除
			selectEnable(row, rowIndex) {
				if (row.pub_flag == that.$store.state.user.userinfo.flag&&row.pub_id == that.$store.state.user.userinfo.id) {
					return true
				}
			},
			//	删除操作
			delData(){
				that.$refs.delDatas.showToast(res => {
					if(res){
						dwgl.delActivity({
							id:that.delList,
							flag:that.$store.state.user.userinfo.flag
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			},
			// 删除
			del(data){
				that.delList = [];
				that.delList = [data.id];
				that.delData();
			},
			// 导出表格
			daochu(){
				dwgl.exportPartyOrgan(that.getdata);
			}
		},
		mounted() {
			that.$emit('selectTop',5)
			that.dataList();
		}
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.xxjl{
			margin-bottom: 15px;
			display: flex;
			font-size: 16px;
			justify-content: space-between;
			div:nth-child(1){
				display: flex;
				align-items: center;
				font-weight: bold;
				img{
					width: 20px;
					margin-left: 10px;
				}
			}
			div:nth-child(2){
				>span{
					margin-left: 30px;
				}
			}
		}
	}
</style>

